<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">扫码记录查询</div>
      <div class="top">
        <div class="select">
            <Input v-model="selectVal" search @on-search="selects" placeholder="输入防伪码或二维码编号" />
        </div>
        <div class="select">
          共 {{allPage}} 条记录
        </div>
      </div>
      <div class="main mains">
        <Table border :columns="columns" :data="pageData" style="width: 100%;">
          <template #name="{ row }">
            <strong>{{ row.name }}</strong>
          </template>

          <template #stat="{ row, index }">
            <span v-if="row.result == '错误'" style="color:white;display:block;background:red;width:50px;height:30px;border-radius:6px;line-height:30px;text-align:center;">错误</span>
            <span v-if="row.result == '正确'" style="color:white;display:block;background:green;width:50px;height:30px;border-radius:6px;line-height:30px;text-align:center;">正确</span>
            <span v-if="row.result == '重复'" style="color:white;display:block;background:blue;width:50px;height:30px;border-radius:6px;line-height:30px;text-align:center;">重复</span>
          </template>
        </Table>
        
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { GetScanRecord } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      // id,serial,number,ip,time,result,location,address,fwcode
      columns: [
        {
          title: "防伪码",
          key: "fwcode",
          width: 180,
        },
        {
          title: "二维码编号",
          key: "serial",
          width: 200,
          minWidth: 200,
        },
        {
          title: "结果",
          key: "result",
          width: 100,
          maxWidth: 100,
          slot: "stat",
          fixed: "right",
        },
        {
          title: "IP地址",
          key: "ip",
          width: 160,
        },
        {
          title: "次数",
          key: "number",
          width: 100,
        },
        {
          title: "查询地址",
          key: "ipEarthly",
          width: 200,
        },
        {
          title: "详细地址",
          key: "location",
          minWidth: 200,
        },
        {
          title: "查询时间",
          key: "time",
          width: 200,
        },
      ],
      // 源数据
      data: [],
      // 搜索后的数据
      inData: [],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
    };
  },
  mounted() {
    this.getCodeLists();

    this.allPage = this.data.length;
  },
  components: {},
  watch: {},
  methods: {
    selects() {
      this.pages = 1
      this.getCodeLists()
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      this.getCodeLists()
    },

    // 获取查询记录
    getCodeLists() {
      GetScanRecord({
        page: this.pages,
        pagesize: 10,
        name: this.selectVal
      }).then((res) => {
        if (res.code == 402) {
          this.$Notice.error({ title: "没有权限！" });
        }
        this.pageData = res.list;
        this.allPage = res.size;
      });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
